export enum Operations {
    Created = 0,
    WaitingApproval = 1,
    Approved = 2,
    Canceled = 3,
    Refused = 4,
    Archived = 5,
    WaitingApprovalChanged = 6,
    WaitingApprovalCommentChanged = 7,
    Seated = 8
}